import { createService as createBackendService } from "@iglu/common/backend";

if (!window.backend) {
  window.backend = createBackendService({ nativeFetchFunction: window.fetch });
}

export default window.backend;
